const gridSpacingLon_1 = 6;
const gridSpacingLat_1 = 4;
const gridSpacingLon_2 = gridSpacingLon_1 / 12;
const gridSpacingLat_2 = gridSpacingLat_1 / 8;
const gridSpacingLon_3 = gridSpacingLon_2 / 2;
const gridSpacingLat_3 = gridSpacingLat_2 / 3;
const gridSpacingLon_4 = gridSpacingLon_3 / 15;
const gridSpacingLat_4 = gridSpacingLat_3 / 10;
const gridSpacingLon_5 = gridSpacingLon_4 / 15;
const gridSpacingLat_5 = gridSpacingLat_4 / 15;
const gridSpacingLon_6 = gridSpacingLon_5 / 2;
const gridSpacingLat_6 = gridSpacingLat_5 / 2;
const gridSpacingLon_7 = gridSpacingLon_6 / 8;
const gridSpacingLat_7 = gridSpacingLat_6 / 8;
const gridSpacingLon_8 = gridSpacingLon_7 / 8;
const gridSpacingLat_8 = gridSpacingLat_7 / 8;
const gridSpacingLon_9 = gridSpacingLon_8 / 8;
const gridSpacingLat_9 = gridSpacingLat_8 / 8;
const gridSpacingLon_10 = gridSpacingLon_9 / 8;
const gridSpacingLat_10 = gridSpacingLat_9 / 8;


// 初始网格,地上、地下划分成两个部分;
// 第一级网格,采用和赤道4°长度一致的划分,每个划分约445.28km;
// 第二级网格,采用和赤道30'长度一致的划分,每个划分约55.66km;
// 第三级网格,采用和赤道15'长度一致的划分,每个划分约27.83km;
// 第四级网格,采用和赤道1长度一致的划分,每个划分约1.85km;
// 第五级网格,采用和赤道4"长度一致的划分,每个划分约123.69m;
// 第六级网格,采用和赤道2"长度一致的划分,每个划分约61.84m;
// 第七级网格,采用和赤道1/4"长度一致的划分,每个划分约7.73m;
// 第八级网格,采用和赤道1/32"长度一致的划分,每个划分约0.97m;
// 第九级网格,采用和赤道1/256"长度一致的划分,每个划分约12.1cm;
// 第十级网格,采用和赤道1/2048"长度一致的划分,每个划分约1.5cm。
const GlobeR = 6378137;

const gridSpacingH_0 = 40075 * 1000;
const gridSpacingH_1 = 445.28 * 1000;
const gridSpacingH_2 = 55.66 * 1000;
const gridSpacingH_3 = 27.83 * 1000;
const gridSpacingH_4 = 1.85 * 1000;
const gridSpacingH_5 = 123.69;
const gridSpacingH_6 = 61.84;
const gridSpacingH_7 = 7.73;
const gridSpacingH_8 = 0.97;
const gridSpacingH_9 = 0.121;
const gridSpacingH_10 = 0.015;

const BeidouGridMap = {
    "bd_1": [gridSpacingLon_1, gridSpacingLat_1, gridSpacingH_1],
    "bd_2": [gridSpacingLon_2, gridSpacingLat_2, gridSpacingH_2],
    "bd_3": [gridSpacingLon_3, gridSpacingLat_3, gridSpacingH_3],
    "bd_4": [gridSpacingLon_4, gridSpacingLat_4, gridSpacingH_4],
    "bd_5": [gridSpacingLon_5, gridSpacingLat_5, gridSpacingH_5],
    "bd_6": [gridSpacingLon_6, gridSpacingLat_6, gridSpacingH_6],
    "bd_7": [gridSpacingLon_7, gridSpacingLat_7, gridSpacingH_7],
    "bd_8": [gridSpacingLon_8, gridSpacingLat_8, gridSpacingH_8],
    "bd_9": [gridSpacingLon_9, gridSpacingLat_9, gridSpacingH_9],
    "bd_10": [gridSpacingLon_10, gridSpacingLat_10, gridSpacingH_10],
}


const BeidouGridHeightCountMap = {
    "bd_1": [8, 4],
    "bd_2": [3, 30 / 60],
    "bd_3": [5, 15 / 60],
    "bd_4": [4, 1 / 60],
    "bd_5": [3, 4 / 3600],
    "bd_6": [4, 2 / 3600],
    "bd_7": [1, 1 / (3600 * 4)],
    "bd_8": [4, 1 / (3600 * 32)],
    "bd_9": [5, 1 / (3600 * 256)],
    "bd_10": [4, 1 / (3600 * 2048)],
}

const BeidouGridHeightAreaMap = {
    "bd_1": [3.8, 53, 73, 135],//全国
    "bd_2": [29, 33, 108, 116],//湖北
    "bd_3": [29, 31, 113, 115],//武汉
    "bd_4": [30.53, 30.62, 114.26, 114.38],//
    "bd_5": [30.538863, 30.588863, 114.26438863, 114.29438863],//
    "bd_6": [30.438863, 30.455008, 114.393434, 114.397145],
    "bd_7": [30.438863, 30.455008, 114.393434, 114.397145],
    "bd_8": [39.9062, 39.9062449, 116.3975, 116.3975449],  //暂不加入
    "bd_9": [30.438863, 30.455008, 114.393434, 114.397145], //暂不加入
    "bd_10": [30.438863, 30.455008, 114.393434, 114.397145],//暂不加入
}


function ProceduralMultiTileVoxelProvider(shape) {
    this.shape = shape;
    this.dimensions = new Cesium.Cartesian3(4, 4, 4);
    this.names = ["color"];
    this.types = [Cesium.MetadataType.VEC4];
    this.componentTypes = [Cesium.MetadataComponentType.FLOAT32];
    this._levelCount = 3;
}

ProceduralMultiTileVoxelProvider.prototype.requestData = function (options) {
    const { tileLevel, tileX, tileY, tileZ } = options;

    if (tileLevel >= this._levelCount) {
        return undefined;
    }

    const dimensions = this.dimensions;
    const type = this.types[0];
    const randomSeed =
        tileZ * dimensions.y * dimensions.x + tileY * dimensions.x + tileX;
    const dataTile = constructRandomTileData(dimensions, type, randomSeed);

    return Promise.resolve([dataTile]);
};

function constructRandomTileData(dimensions, type, randomSeed) {
    Cesium.Math.setRandomNumberSeed(randomSeed);
    const voxelCount = dimensions.x * dimensions.y * dimensions.z;
    const channelCount = Cesium.MetadataType.getComponentCount(type);
    const dataColor = new Float32Array(voxelCount * channelCount);

    dataColor[index + 0] = color.red;
    dataColor[index + 1] = color.green;
    dataColor[index + 2] = color.blue;
    dataColor[index + 3] = alphaRandom;

    return dataColor;
}


//https://blog.csdn.net/hsg77/article/details/140935524
class BeidouGrid {
    constructor(op) {

        this.viewer = op.viewer || viewer;
        this.geodesic = new Cesium.EllipsoidGeodesic();
        this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
        this.wheelEventListener = undefined;
        this.gridPrimitives = undefined;
        this.labelPrimitives = undefined;
        this.bdlevel = "bd_1";//默认是一级
        this.viewer.scene.fxaa = true;
        // 抗锯齿
        this.viewer.scene.postProcessStages.fxaa.enabled = true
        this.viewer._cesiumWidget._supportsImageRenderingPixelated = Cesium.FeatureDetection.supportsImageRenderingPixelated()
        this.viewer._cesiumWidget._forceResize = true
        // 是否支持图像渲染像素化处理
        //   if (Cesium.FeatureDetection.supportsImageRenderingPixelated()) {
        //     let dpr = window.devicePixelRatio
        //     while (dpr >= 2.0) {
        //       dpr /= 2.0
        //     }
        //     viewer.resolutionScale = dpr;
        //   }
        this.init();

    }
    drawLine() {
        var start = { lon: 117.228884, lat: 31.817408, h: 2 };
        var end = { lon: 117.22945, lat: 31.817904, h: 20 };
        const lineGridInstances = this.drawLineGridPrimitives3D(start, end, "bd_8", 0, 21);
        let line = this.drawLineEntity(start, end)
        viewer.zoomTo(line);

        // 创建一个新的 PrimitiveCollection
        this.gridPrimitives = viewer.scene.primitives.add(new Cesium.PrimitiveCollection());

        let geometryInstances = [];
        lineGridInstances.forEach(item => {

            const { pA_b, pB_b, pC_b, pD_b, pA_t, pB_t, pC_t, pD_t } = item;

            this.drawEntityPoint(pA_b)
            this.drawEntityPoint(pB_b)
            this.drawEntityPoint(pC_b)
            this.drawEntityPoint(pD_b)
            this.drawEntityPoint(pA_t)
            this.drawEntityPoint(pB_t)
            this.drawEntityPoint(pC_t)
            let p = this.drawEntityPoint(pD_t)

            viewer.zoomTo(p);

            let pA_b_ = Cesium.Cartesian3.fromDegrees(pA_b.x, pA_b.y, pA_b.z)
            let pB_b_ = Cesium.Cartesian3.fromDegrees(pB_b.x, pB_b.y, pB_b.z)
            let pC_b_ = Cesium.Cartesian3.fromDegrees(pC_b.x, pC_b.y, pC_b.z)
            let pD_b_ = Cesium.Cartesian3.fromDegrees(pD_b.x, pD_b.y, pD_b.z)
            let pA_t_ = Cesium.Cartesian3.fromDegrees(pA_t.x, pA_t.y, pA_t.z)
            let pB_t_ = Cesium.Cartesian3.fromDegrees(pB_t.x, pB_t.y, pB_t.z)
            let pC_t_ = Cesium.Cartesian3.fromDegrees(pC_t.x, pC_t.y, pC_t.z)
            let pD_t_ = Cesium.Cartesian3.fromDegrees(pD_t.x, pD_t.y, pD_t.z)

            let positions = new Float64Array([
                pA_b_.x, pA_b_.y, pA_b_.z,  // 顶点0：pA_b
                pB_b_.x, pB_b_.y, pB_b_.z,  // 顶点1：pB_b
                pC_b_.x, pC_b_.y, pC_b_.z,  // 顶点2：pC_b
                pD_b_.x, pD_b_.y, pD_b_.z,  // 顶点3：pD_b
                pA_t_.x, pA_t_.y, pA_t_.z,  // 顶点4：pA_t
                pB_t_.x, pB_t_.y, pB_t_.z,  // 顶点5：pB_t
                pC_t_.x, pC_t_.y, pC_t_.z,  // 顶点6：pC_t
                pD_t_.x, pD_t_.y, pD_t_.z   // 顶点7：pD_t
            ]);

            var trapezoid = this.createTrapezoid(positions);

            geometryInstances.push(trapezoid)

        })

        this.gridPrimitives = viewer.scene.primitives.add(new Cesium.PrimitiveCollection());

        // 创建一个 Primitive 用于显示线
        var fillPrimitive = new Cesium.Primitive({
            geometryInstances: geometryInstances,
            appearance: new Cesium.PolylineMaterialAppearance({
                material: Cesium.Material.fromType('Color', {
                    color: Cesium.Color.WHITE.withAlpha(0.3)
                })
            }),
            asynchronous: true
        });
        this.gridPrimitives.add(fillPrimitive);
    }
    init() {
        //let scale = this.calculateScale();
        // let bdlevel = this.getBeidouGridMap();
        // //this.drawGridPrimitives2D(bdlevel);
        // this.drawGridPrimitives3D(bdlevel);
        // label
        this.labelPrimitives = viewer.scene.primitives.add(new Cesium.LabelCollection());
        this.doDrawGrid();


        // 监听相机移动完成事件
        // viewer.camera.moveEnd.addEventListener(() => {
        //     const height = viewer.camera.positionCartographic.height;
        //     console.log('height', height)
        //     let bdlevel = this.getBeidouGridMap();
        //     console.log('级别', bdlevel)
        //     if (bdlevel != this.bdlevel) {
        //         this.doDrawGrid()
        //     }
        // });

    }
    clear() {
        if (this.gridPrimitives) {
            this.viewer.scene.primitives.remove(this.gridPrimitives);
            this.gridPrimitives = undefined;

            //移除lable
            this.labelPrimitives.removeAll();
        }
    }
    getNextMultipleA(num, multiple) {
        // 计算小于或等于 num 的最大倍数
        return Math.floor(num / multiple) * multiple;
    }
    getNextMultipleB(num, multiple) {
        // 计算小于或等于 num 的最大倍数
        return Math.ceil(num / multiple) * multiple;
    }
    /*
    * 绘制全球网格（6° x 4°）并使用 Primitive 添加到场景中
    */
    drawGridPrimitives2D() {
        console.log("当前层级: ", this.bdlevel);
        // 第一级网格的经纬度间距
        var gridSpacingLon = BeidouGridMap[this.bdlevel][0];  // 经度间距 6°
        var gridSpacingLat = BeidouGridMap[this.bdlevel][1];  // 纬度间距 4°
        var minLat = -88;  // 最小纬度
        var maxLat = 88;   // 最大纬度
        var minLon = -180; // 最小经度
        var maxLon = 180;  // 最大经度

        // 获取当前视角的矩形范围
        var viewRectangle = viewer.camera.computeViewRectangle();

        console.log("gridSpacingLon", gridSpacingLon)
        console.log("gridSpacingLat", gridSpacingLat)


        // 转换弧度为度
        minLat = this.getNextMultipleB(Cesium.Math.toDegrees(viewRectangle.south), gridSpacingLat);  // 最小纬度
        maxLat = this.getNextMultipleA(Cesium.Math.toDegrees(viewRectangle.north), gridSpacingLat);  // 最大纬度
        minLon = this.getNextMultipleA(Cesium.Math.toDegrees(viewRectangle.west), gridSpacingLon);   // 最小经度
        maxLon = this.getNextMultipleB(Cesium.Math.toDegrees(viewRectangle.east), gridSpacingLon);   // 最大经度

        // 存储 GeometryInstance
        var geometryInstances = [];
        var borderInstances = [];

        // 遍历第一级网格的纬度和经度范围，生成网格的矩形
        for (var lat = minLat; lat < maxLat; lat += gridSpacingLat) {
            for (var lon = minLon; lon < maxLon; lon += gridSpacingLon) {
                // 计算每个第一级网格的矩形范围
                var west = Cesium.Math.toRadians(lon); // 西边界
                var east = Cesium.Math.toRadians(lon + gridSpacingLon); // 东边界
                var south = Cesium.Math.toRadians(lat); // 南边界
                var north = Cesium.Math.toRadians(lat + gridSpacingLat); // 北边界

                var gridRectangle = new Cesium.Rectangle(west, south, east, north);

                // 创建矩形几何体
                var rectangleGeometry = new Cesium.RectangleGeometry({
                    rectangle: gridRectangle
                });
                geometryInstances.push(new Cesium.GeometryInstance({
                    geometry: rectangleGeometry
                }));

                // 创建网格的边框
                var positions = [
                    Cesium.Cartesian3.fromRadians(west, south),
                    Cesium.Cartesian3.fromRadians(east, south),
                    Cesium.Cartesian3.fromRadians(east, north),
                    Cesium.Cartesian3.fromRadians(west, north),
                    Cesium.Cartesian3.fromRadians(west, south) // 闭合边框
                ];

                var polylineGeometry = new Cesium.PolylineGeometry({
                    positions: positions,
                    width: 2.0 // 设置边框线宽
                });

                borderInstances.push(new Cesium.GeometryInstance({
                    geometry: polylineGeometry
                }));

            }
        }

        // 创建一个新的 PrimitiveCollection
        this.gridPrimitives = viewer.scene.primitives.add(new Cesium.PrimitiveCollection());

        // 创建一个 Primitive 用于显示第一级矩形（网格）
        var fillPrimitive = new Cesium.Primitive({
            geometryInstances: geometryInstances,
            appearance: new Cesium.EllipsoidSurfaceAppearance({
                material: Cesium.Material.fromType('Color', {
                    color: Cesium.Color.YELLOW.withAlpha(0.3)
                })
            }),
            asynchronous: true
        });

        // 创建一个 Primitive 用于显示矩形边框（边框线）
        var borderPrimitive = new Cesium.Primitive({
            geometryInstances: borderInstances,
            appearance: new Cesium.PolylineMaterialAppearance({
                material: Cesium.Material.fromType('Color', {
                    color: Cesium.Color.RED // 红色边框
                })
            }),
            asynchronous: true
        });

        // 将两个 Primitive 添加到新创建的 PrimitiveCollection 中
        this.gridPrimitives.add(fillPrimitive);
        this.gridPrimitives.add(borderPrimitive);

    }
    drawGridPrimitives3D() {
        console.log("当前层级: ", this.bdlevel);
        let scene = viewer.scene;
        let ellipsoid = scene.globe.ellipsoid;
        // 第一级网格的经纬度间距
        var gridSpacingLon = BeidouGridMap[this.bdlevel][0];  // 经度间距 6°
        var gridSpacingLat = BeidouGridMap[this.bdlevel][1];  // 纬度间距 4°
        var gridSpacingHeight = BeidouGridMap[this.bdlevel][2];
        var minLat = -88;  // 最小纬度
        var maxLat = 88;   // 最大纬度
        var minLon = -180; // 最小经度
        var maxLon = 180;  // 最大经度
        var gridHeightCount = BeidouGridHeightCountMap[this.bdlevel][0];//   //Math.pow(2, Number(this.bdlevel.split("_")[1]) - 1)
        // 获取当前视角的矩形范围
        // var viewRectangle = viewer.camera.computeViewRectangle();

        //    中国的大致经纬度范围为：
        //    经度：73.667°E 到 135.083°E
        //    纬度：3.867°N 到 53.550°N

        console.log("gridSpacingLon", gridSpacingLon)
        console.log("gridSpacingLat", gridSpacingLat)


        // 转换弧度为度
        minLat = BeidouGridHeightAreaMap[this.bdlevel][0];// this.getNextMultipleB(Cesium.Math.toDegrees(viewRectangle.south), gridSpacingLat);  // 最小纬度
        maxLat = BeidouGridHeightAreaMap[this.bdlevel][1];//this.getNextMultipleB(Cesium.Math.toDegrees(viewRectangle.north), gridSpacingLat);  // 最大纬度
        minLon = BeidouGridHeightAreaMap[this.bdlevel][2];// this.getNextMultipleB(Cesium.Math.toDegrees(viewRectangle.west), gridSpacingLon);   // 最小经度
        maxLon = BeidouGridHeightAreaMap[this.bdlevel][3];// this.getNextMultipleB(Cesium.Math.toDegrees(viewRectangle.east), gridSpacingLon);   // 最大经度
        minLat = minLat <= -88 ? -88 : minLat;
        maxLat = maxLat >= 88 ? 88 : maxLat;
        const rectangle = Cesium.Rectangle.fromDegrees(minLon, minLat, maxLon, maxLat);
        var cartographic_c = Cesium.Rectangle.center(rectangle);
        var center = Cesium.Cartesian3.fromRadians(cartographic_c.longitude, cartographic_c.latitude, viewer.camera.positionCartographic.height);

        viewer.camera.setView({
            destination: center
        });

        // 存储 GeometryInstance
        var geometryInstances = [];
        // 遍历第一级网格的纬度和经度范围，生成网格的矩形
        let Ri = GlobeR;
        let sta = BeidouGridHeightCountMap[this.bdlevel][1];
        let Li = 0;
        for (var m = 0; m < gridHeightCount; m++) {
            let distance = 0;
            Li = (Ri * Math.PI * sta) / 180;
            distance = distance + Li;
            for (var lat = minLat; lat <= maxLat; lat += gridSpacingLat) {
                for (var lon = minLon; lon <= maxLon; lon += gridSpacingLon) {
                    // 计算每个第一级网格的矩形范围
                    // var west = Cesium.Math.toRadians(lon); // 西边界
                    // var east = Cesium.Math.toRadians(lon + gridSpacingLon); // 东边界
                    // var south = Cesium.Math.toRadians(lat); // 南边界
                    // var north = Cesium.Math.toRadians(lat + gridSpacingLat); // 北边界

                    // var gridRectangle = new Cesium.Rectangle(west, south, east, north);

                    // var cartographic_c = Cesium.Rectangle.center(gridRectangle);
                    // var centerH = (m + 1) * gridSpacingHeight - gridSpacingHeight / 2;
                    // var center = Cesium.Cartesian3.fromRadians(cartographic_c.longitude, cartographic_c.latitude, centerH);



                    // var center_west = new Cesium.Cartographic(west, (south + north) / 2);
                    // var center_east = new Cesium.Cartographic(east, (south + north) / 2);
                    // let geodesic = this.geodesic;
                    // geodesic.setEndPoints(center_west, center_east);//Cartographic
                    // let distance_x = geodesic.surfaceDistance;

                    // var center_north = new Cesium.Cartographic((west + east) / 2, north);
                    // var center_south = new Cesium.Cartographic((west + east) / 2, south);
                    // geodesic.setEndPoints(center_north, center_south);//Cartographic
                    // let distance_y = geodesic.surfaceDistance;

                    // const box = Cesium.BoxGeometry.fromDimensions({
                    //     dimensions: new Cesium.Cartesian3(distance_x, distance_y, gridSpacingHeight)
                    // });
                    // const geometry = Cesium.BoxGeometry.createGeometry(box);
                    // const boxInstance = new Cesium.GeometryInstance({
                    //     geometry: geometry,
                    //     modelMatrix: Cesium.Transforms.eastNorthUpToFixedFrame(center),
                    // });
                    //geometryInstances.push(boxInstance)
                    // let cartesian = Cesium.Cartesian3.fromRadians(west, south, 0);
                    // // 计算法向量
                    // var normal = ellipsoid.geodeticSurfaceNormal(cartesian);
                    // 延长法向量
                    //var distance = (m + 1) * gridSpacingHeight; // 延长的距离，单位：米

                    //distance = 1000000;
                    // var extendedCartesian = Cesium.Cartesian3.add(cartesian, Cesium.Cartesian3.multiplyByScalar(normal, distance, new Cesium.Cartesian3()), new Cesium.Cartesian3());

                    // let cartesianB = Cesium.Cartesian3.fromRadians(east, south, 0);
                    // var normalB = ellipsoid.geodeticSurfaceNormal(cartesianB);
                    // var extendedCartesianB = Cesium.Cartesian3.add(cartesianB, Cesium.Cartesian3.multiplyByScalar(normalB, distance, new Cesium.Cartesian3()), new Cesium.Cartesian3());


                    // let cartesianC = Cesium.Cartesian3.fromRadians(west, north, 0);
                    // var normalC = ellipsoid.geodeticSurfaceNormal(cartesianC);
                    // var extendedCartesianC = Cesium.Cartesian3.add(cartesianC, Cesium.Cartesian3.multiplyByScalar(normalC, distance, new Cesium.Cartesian3()), new Cesium.Cartesian3());

                    // 输出延长后的点坐标
                    console.log('圆心角：——' + m, sta);
                    console.log('延长距离：——' + m, distance);

                    // 调用函数创建梯形立方体
                    var trapezoid = this.createTrapezoidByGrid(lon, lat, gridSpacingLon, gridSpacingLat, Ri - GlobeR, Ri + distance - GlobeR);
                    geometryInstances.push(trapezoid);
                    let code = BeidouGrid.calculateGridCode3D_All(trapezoid.centerArr[0], trapezoid.centerArr[1], trapezoid.centerArr[2], Number(this.bdlevel.split("_")[1]))

                    this.labelPrimitives.add({
                        position: trapezoid.center,
                        fillColor: Cesium.Color.WHITE,
                        font: "14px sans-serif",
                        pixelOffset: new Cesium.Cartesian2(-10, 0),
                        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                        verticalOrigin: Cesium.VerticalOrigin.CENTER,
                        text: '北斗网格码\r' + code
                    });

                    // // 创建 PolylineGeometry
                    // var polylineGeometry = new Cesium.PolylineGeometry({
                    //     positions: [cartesian, extendedCartesian],
                    //     width: 2 // 设置边框线宽
                    // });

                    // // 创建 GeometryInstance
                    // var line = new Cesium.GeometryInstance({
                    //     geometry: polylineGeometry
                    // });


                    // // 创建 PolylineGeometry
                    // var polylineGeometryB = new Cesium.PolylineGeometry({
                    //     positions: [extendedCartesian, extendedCartesianB],
                    //     width: 2 // 设置边框线宽
                    // });

                    // // 创建 GeometryInstance
                    // var lineB = new Cesium.GeometryInstance({
                    //     geometry: polylineGeometryB
                    // });

                    // var polylineGeometryC = new Cesium.PolylineGeometry({
                    //     positions: [extendedCartesian, extendedCartesianC],
                    //     width: 2 // 设置边框线宽
                    // });

                    // // 创建 GeometryInstance
                    // var lineC = new Cesium.GeometryInstance({
                    //     geometry: polylineGeometryC
                    // });


                    // // 添加到 GeometryInstance 存储
                    // geometryInstances.push(line);

                    // if (lon < maxLon) {
                    //     geometryInstances.push(lineB);

                    // }

                    // if (lat < maxLat) {
                    //     geometryInstances.push(lineC);

                    // }
                }

            }

            Ri = Ri + distance;
        }

        // 创建一个新的 PrimitiveCollection
        this.gridPrimitives = viewer.scene.primitives.add(new Cesium.PrimitiveCollection());

        // 创建一个 Primitive 用于显示线
        var fillPrimitive = new Cesium.Primitive({
            geometryInstances: geometryInstances,
            appearance: new Cesium.PolylineMaterialAppearance({
                material: Cesium.Material.fromType('Color', {
                    color: Cesium.Color.WHITE.withAlpha(0.3)
                })
            }),
            asynchronous: true
        });
        this.gridPrimitives.add(fillPrimitive);
    }

    doDrawGrid() {

        this.bdlevel = this.getBeidouGridMap();
        // 清空之前的网格
        if (this.gridPrimitives) {
            this.viewer.scene.primitives.remove(this.gridPrimitives);
            this.gridPrimitives = undefined;

            //移除lable
            this.labelPrimitives.removeAll();
        }

        // 重新绘制新网格
        this.drawGridPrimitives3D();

    }

    // 添加鼠标滚动事件
    addWheelEvent() {
        this.wheelCallback = (delta) => {
            //let scale = this.calculateScale();
            var scale = viewer.scene.globe._surface._debug.maxDepthVisited;
            let level = Math.floor(scale / 2.8);
            level = level <= 1 ? 1 : level;
            level = level >= 10 ? 10 : level;
            console.log("当前瓦片层", level);
            let bdlevel = "bd_" + level;//this.getBeidouGridMap(level);
            this.doDrawGrid(bdlevel)

        };
        this.handler.setInputAction(this.wheelCallback, Cesium.ScreenSpaceEventType.WHEEL);
    }

    // 移除鼠标滚动事件
    removeWheelEvent() {
        if (this.wheelCallback) {
            this.handler.removeInputAction(Cesium.ScreenSpaceEventType.WHEEL, this.wheelCallback);
            this.wheelCallback = null; // 清除回调函数引用
        }
    }

    //获取当前范围
    showViewRectangle() {
        // 获取视野边界坐标
        const viewRectangle = viewer.camera.computeViewRectangle();
        // 检查是否成功获取视野边界
        if (viewRectangle) {
            // 将弧度转换为度数
            const west = Cesium.Math.toDegrees(viewRectangle.west);
            const south = Cesium.Math.toDegrees(viewRectangle.south);
            const east = Cesium.Math.toDegrees(viewRectangle.east);
            const north = Cesium.Math.toDegrees(viewRectangle.north);

            // 创建矩形实体
            const rectangleEntity = viewer.entities.add({
                rectangle: {
                    coordinates: Cesium.Rectangle.fromDegrees(west, south, east, north),
                    material: Cesium.Color.RED.withAlpha(0.5), // 设置矩形颜色和透明度
                    outline: true, // 是否显示边框
                    outlineColor: Cesium.Color.BLACK // 边框颜色
                }
            });

            // 调整相机视角以更好地查看矩形
            //viewer.flyTo(rectangleEntity);
        } else {
            console.log('无法获取视野边界');
        }

    }
    calculateScale() {
        let scene = viewer.scene;
        let width = scene.canvas.clientWidth;
        let height = scene.canvas.clientHeight;
        let left = scene.camera.getPickRay(new Cesium.Cartesian2(0, height / 2));
        let right = scene.camera.getPickRay(new Cesium.Cartesian2(width, height / 2));
        let globe = scene.globe;
        let leftPosition = globe.pick(left, scene);
        let rightPosition = globe.pick(right, scene);
        if (!leftPosition || !rightPosition) return;

        let geodesic = new Cesium.EllipsoidGeodesic();
        let leftCartographic = globe.ellipsoid.cartesianToCartographic(leftPosition);
        let rightCartographic = globe.ellipsoid.cartesianToCartographic(rightPosition);
        geodesic.setEndPoints(leftCartographic, rightCartographic);
        let pixelDistance = geodesic.surfaceDistance;
        let resolution = pixelDistance / width;
        let scale = Math.floor(resolution * 96 / 0.0254); // 96 DPI and 0.0254 meters per inch
        console.log("当前比例尺比例: ", scale);
        return scale;
    }
    /**
     * 
     * @param {*} lon 西南角经度
     * @param {*} lat 西南角纬度
     * @param {*} gridSpacingLon 网格经度差
     * @param {*} gridSpacingLat 网格经纬度
     * @param {*} hA 网格底部高度
     * @param {*} hB 网格顶部高度
     */
    createTrapezoidByGrid(lon, lat, gridSpacingLon, gridSpacingLat, hA, hB) {
        let scene = viewer.scene;
        let ellipsoid = scene.globe.ellipsoid;
        let distance = hB - hA;
        var west = Cesium.Math.toRadians(lon); // 西边界
        var east = Cesium.Math.toRadians(lon + gridSpacingLon); // 东边界
        var south = Cesium.Math.toRadians(lat); // 南边界
        var north = Cesium.Math.toRadians(lat + gridSpacingLat); // 北边界
        var gridRectangle = new Cesium.Rectangle(west, south, east, north);
        var cartographic_c = Cesium.Rectangle.center(gridRectangle);
        var center = Cesium.Cartesian3.fromRadians(cartographic_c.longitude, cartographic_c.latitude, hA + distance / 2);

        let pA_b = Cesium.Cartesian3.fromRadians(west, south, hA);
        let pB_b = Cesium.Cartesian3.fromRadians(east, south, hA);
        let pC_b = Cesium.Cartesian3.fromRadians(east, north, hA);
        let pD_b = Cesium.Cartesian3.fromRadians(west, north, hA);
        let pA_t = Cesium.Cartesian3.add(pA_b, Cesium.Cartesian3.multiplyByScalar(ellipsoid.geodeticSurfaceNormal(pA_b), distance, new Cesium.Cartesian3()), new Cesium.Cartesian3());
        let pB_t = Cesium.Cartesian3.add(pB_b, Cesium.Cartesian3.multiplyByScalar(ellipsoid.geodeticSurfaceNormal(pB_b), distance, new Cesium.Cartesian3()), new Cesium.Cartesian3());
        let pC_t = Cesium.Cartesian3.add(pC_b, Cesium.Cartesian3.multiplyByScalar(ellipsoid.geodeticSurfaceNormal(pC_b), distance, new Cesium.Cartesian3()), new Cesium.Cartesian3());
        let pD_t = Cesium.Cartesian3.add(pD_b, Cesium.Cartesian3.multiplyByScalar(ellipsoid.geodeticSurfaceNormal(pD_b), distance, new Cesium.Cartesian3()), new Cesium.Cartesian3());

        // var vertices = [
        //     // 底部四个顶点（较大的矩形）
        //     pA_b.x, pA_b.y, pA_b.z,  // 顶点0
        //     pB_b.x, pB_b.y, pB_b.z,   // 顶点1
        //     pC_b.x, pC_b.y, pC_b.z,    // 顶点2
        //     pD_b.x, pD_b.y, pD_b.z,   // 顶点3

        //     // 顶部四个顶点（较小的矩形）
        //     pA_t.x, pA_t.y, pA_t.z,    // 顶点4
        //     pB_t.x, pB_t.y, pB_t.z,   // 顶点5
        //     pC_t.x, pC_t.y, pC_t.z,     // 顶点6
        //     pD_t.x, pD_t.y, pD_t.z,    // 顶点7
        // ];

        // 定义 positions 数组
        let positions = new Float64Array([
            pA_b.x, pA_b.y, pA_b.z,  // 顶点0：pA_b
            pB_b.x, pB_b.y, pB_b.z,  // 顶点1：pB_b
            pC_b.x, pC_b.y, pC_b.z,  // 顶点2：pC_b
            pD_b.x, pD_b.y, pD_b.z,  // 顶点3：pD_b
            pA_t.x, pA_t.y, pA_t.z,  // 顶点4：pA_t
            pB_t.x, pB_t.y, pB_t.z,  // 顶点5：pB_t
            pC_t.x, pC_t.y, pC_t.z,  // 顶点6：pC_t
            pD_t.x, pD_t.y, pD_t.z   // 顶点7：pD_t
        ]);

        var trapezoid = this.createTrapezoid(positions);
        trapezoid.center = center;
        trapezoid.centerArr = [Cesium.Math.toDegrees(cartographic_c.longitude), Cesium.Math.toDegrees(cartographic_c.latitude), hA + distance / 2]
        return trapezoid;
    }
    //构建每一个方格网
    createTrapezoid(vertices) {
        if (!vertices || vertices.length !== 24) {
            console.error("需要提供8个顶点的坐标，每个顶点3个分量（x, y, z），共24个值。");
            return;
        }

        // 创建几何体
        const positions = new Float64Array(vertices);
        // 定义法线
        var normals = [
            // 底部
            0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0,
            // 顶部
            0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0,
            // 前面
            0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1,
            // 右侧
            1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0,
            // 后面
            0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1,
            // 左侧
            -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0
        ];
        const geometry = new Cesium.Geometry({
            attributes: {
                position: new Cesium.GeometryAttribute({
                    componentDatatype: Cesium.ComponentDatatype.DOUBLE,
                    componentsPerAttribute: 3,
                    values: positions
                }),
                // normal: new Cesium.GeometryAttribute({
                //     componentDatatype: Cesium.ComponentDatatype.FLOAT,
                //     componentsPerAttribute: 3,
                //     values: new Float32Array(normals)
                // })
            },
            // indices: new Uint16Array([
            //     // 底部
            //     0, 1, 2, 0, 2, 3,
            //     // 顶部
            //     4, 5, 6, 4, 6, 7,
            //     // 前面
            //     0, 1, 4, 1, 5, 4,
            //     // 右侧
            //     1, 2, 5, 2, 6, 5,
            //     // 后面
            //     2, 3, 6, 3, 7, 6,
            //     // 左侧
            //     3, 0, 7, 0, 4, 7
            // ]),
            indices: new Uint16Array([
                // 底部边框
                0, 1, 1, 2, 2, 3, 3, 0,
                // 顶部边框
                4, 5, 5, 6, 6, 7, 7, 4,
                // 前面边框
                0, 4, 1, 5,
                // 后面边框
                2, 6, 3, 7,
                // 左边边框
                0, 3, 4, 7,
                // 右边边框
                1, 2, 5, 6
            ]),
            //primitiveType: Cesium.PrimitiveType.TRIANGLES,
            primitiveType: Cesium.PrimitiveType.LINES,
            boundingSphere: Cesium.BoundingSphere.fromVertices(positions)
        });

        // 创建几何实例
        var instance = new Cesium.GeometryInstance({
            geometry: geometry,
            attributes: {
                color: Cesium.ColorGeometryInstanceAttribute.fromColor(Cesium.Color.WHITE.withAlpha(1.0))
            }
        });

        // 添加到场景中
        // var primitive = new Cesium.Primitive({
        //     geometryInstances: instance,
        //     appearance: new Cesium.PerInstanceColorAppearance({
        //         flat: true,
        //         translucent: true,
        //     })
        // });
        return instance;
    }
    addcube() {
        // 定义立方体的几何实例
        var geometryInstances = new Cesium.GeometryInstance({
            geometry: Cesium.BoxGeometry.fromDimensions({
                // 立方体的中心位置
                center: Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 500000.0),
                // 立方体的尺寸
                x: 100000.0,
                y: 100000.0,
                z: 100000.0
            }),
        });

        // 创建一个Primitive来渲染几何实例
        var fillPrimitive = new Cesium.Primitive({
            geometryInstances: geometryInstances,
            appearance: new Cesium.EllipsoidSurfaceAppearance({
                material: Cesium.Material.fromType('Color', {
                    color: Cesium.Color.YELLOW.withAlpha(0.3)
                })
            }),
            asynchronous: true
        });
    }
    getBeidouGridMap() {
        const height = viewer.camera.positionCartographic.height;
        // console.log('height', height)

        return "bd_8";

        if (height <= 41) {
            return "bd_7";
        }
        if (height <= 136) {
            return "bd_6";
        }
        if (height <= 1917) {
            return "bd_5";
        }
        if (height <= 22334) {
            return "bd_4";
        }
        if (height <= 135584) {
            return "bd_3";
        }
        if (height <= 948976) {
            return "bd_2";
        }
        return "bd_1";
    }
    //
    /**


    /**
 * 根据起点和终点坐标绘制线路上的3D网格码
 * @param {Object} start - 起点 {lon, lat, height} 单位：度、米
 * @param {Object} end   - 终点 {lon, lat, height} 单位：度、米
 * @param {number} bdlevel - 网格级别（与 BeidouGridMap 对应）
 * @param {number} [heightLevels] - 每网格绘制的高度层数（可选，默认使用 BeidouGridHeightCountMap[bdlevel][0]）
 * @returns {Array} geometryInstances - 可直接添加到 Cesium PrimitiveCollection
 */
    drawGridPrimitives3DForLine(start, end, bdlevel, heightLevels) {
        console.log("线路网格绘制 - bdlevel:", bdlevel);
        console.log("起点:", start);
        console.log("终点:", end);

        const gridSpacingLon = BeidouGridMap[bdlevel][0];  // 经度间距
        const gridSpacingLat = BeidouGridMap[bdlevel][1];  // 纬度间距

        var center = Cesium.Cartesian3.fromDegrees(start.lon, start.lat, start.height);

        viewer.camera.flyTo({
            destination: center,
            duration: 3,
        });
        // 存储 GeometryInstance
        var geometryInstances = [];


        // 高度层数（可手动指定，或按原函数规则取）
        const gridHeightCount = heightLevels !== undefined
            ? heightLevels
            : BeidouGridHeightCountMap[bdlevel][0];

        // 采样点数量（越多越精确，建议根据距离动态调整）
        const numSamples = 200;  // 通常足够覆盖短至中距离线路

        // 记录所有经过的网格（使用字符串 key 去重）
        const gridSet = new Set();

        for (let i = 0; i <= numSamples; i++) {
            const t = i / numSamples;
            const lon = start.lon + t * (end.lon - start.lon);
            const lat = start.lat + t * (end.lat - start.lat);
            const height = start.height + t * (end.height - start.height);  // 线性插值高度

            // 计算该点所属网格的左下角坐标（北斗网格通常以左下角为基准）
            const gridLon = Math.floor(lon / gridSpacingLon) * gridSpacingLon;
            const gridLat = Math.floor(lat / gridSpacingLat) * gridSpacingLat;

            // 加入去重集合
            const key = `${gridLon.toFixed(6)}_${gridLat.toFixed(6)}`;
            if (!gridSet.has(key)) {
                gridSet.add(key);

                // 网格中心点（用于 createTrapezoidByGrid）
                const centerLon = gridLon + gridSpacingLon / 2;
                const centerLat = gridLat + gridSpacingLat / 2;

                // 高度层循环（从地面向上）
                let Ri = GlobeR;
                let distance = 0;
                const sta = BeidouGridHeightCountMap[bdlevel][1];  // 角度步长（与原函数一致）

                for (let m = 0; m < gridHeightCount; m++) {
                    const Li = (Ri * Math.PI * sta) / 180;
                    distance += Li;

                    console.log(`网格 (${gridLon.toFixed(4)}, ${gridLat.toFixed(4)}) 层 ${m}: 圆心角 ${sta}°, 累积距离 ${distance.toFixed(0)}m`);

                    // 创建该层梯形体（内径 Ri - GlobeR，外径 Ri + distance - GlobeR）
                    const trapezoid = this.createTrapezoidByGrid(
                        centerLon, centerLat,
                        gridSpacingLon, gridSpacingLat,
                        Ri - GlobeR,
                        Ri + distance - GlobeR
                    );

                    geometryInstances.push(trapezoid);

                    Ri += distance;  // 下一层从上一层外径开始
                }
            }
        }

        // 创建一个新的 PrimitiveCollection
        this.gridPrimitives = viewer.scene.primitives.add(new Cesium.PrimitiveCollection());

        // 创建一个 Primitive 用于显示线
        var fillPrimitive = new Cesium.Primitive({
            geometryInstances: geometryInstances,
            appearance: new Cesium.PolylineMaterialAppearance({
                material: Cesium.Material.fromType('Color', {
                    color: Cesium.Color.WHITE.withAlpha(0.3)
                })
            }),
            asynchronous: true
        });
        this.gridPrimitives.add(fillPrimitive);
        return geometryInstances;
    }


    /**
     * 
     * @param {*} start 起点
     * @param {*} end 终点
     * @param {*} bdlevel 级别
     * @param {*} slevel 开始层级
     * @param {*} elevel 结束层级
     * @returns 
     */
    drawLineGridPrimitives3D(start, end, bdlevel, slevel, elevel) {

        console.log("线路层级:", bdlevel);

        // 1️⃣ 计算射线最小包围矩形
        var rect = getLineMinRect(start, end);

        // 2️⃣ 直接使用你原来的函数，生成“最小区域内的全部网格”
        var allGrids = drawGridPrimitives3D(rect, bdlevel, slevel, elevel);

        console.log("候选网格数量:", allGrids);

        // 3️⃣ 逐个判断射线是否与梯形体相交
        var hitGrids = [];

        for (var i = 0; i < allGrids.length; i++) {
            var trapezoid = allGrids[i];

            if (lineIntersectsTrapezoid3D(start, end, trapezoid)) {
                hitGrids.push(trapezoid);
            }
        }

        console.log("命中网格数量:", hitGrids);

        return hitGrids;
    }


    /**
 * 使用 Entity 绘制一条从起点到终点的 3D 线路（推荐方式）
 * @param {Object} start - {lon, lat, height}
 * @param {Object} end   - {lon, lat, height}
 * @param {Object} [options] - 可选参数
 * @param {string} [options.name] - 实体名称（用于拾取）
 * @param {Cesium.Color} [options.color] - 线条颜色
 * @param {number} [options.width] - 线宽（像素）
 * @param {number} [options.heightOffset] - 额外高度偏移（米）
 * @param {boolean} [options.show] - 是否显示，默认 true
 * @returns {Cesium.Entity} - 返回创建的 Entity，可随时修改
 */
    drawLineEntity(start, end) {
        const positions = [];
        positions.push(Cesium.Cartesian3.fromDegrees(start.lon, start.lat, start.h));
        positions.push(Cesium.Cartesian3.fromDegrees(end.lon, end.lat, end.h));

        // 创建 Entity
        const entity = viewer.entities.add({
            polyline: {
                positions: positions,
                material: new Cesium.PolylineOutlineMaterialProperty({
                    color: Cesium.Color.RED.withAlpha(0.9),
                    outlineColor: Cesium.Color.BLACK.withAlpha(0.5),
                    outlineWidth: 2
                }),
            }
        });

        return entity;
    }

    drawEntityPoint(point, options = {}) {
        var size = options.size || 8.0;
        var color = options.color || Cesium.Color.RED;
        var outlineColor = options.outlineColor || Cesium.Color.WHITE;

        var entity = viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(point.x, point.y, point.z),
            point: {
                pixelSize: size,
                color: color,
                outlineColor: outlineColor,
                outlineWidth: 1
            }
        });

        return entity;
    }


}

// 标准化起点终点，确保含 z
function normalizePoint(p) {
    return {
        x: p.lon,
        y: p.lat,
        z: p.h || 0
    };
}

/**
 * 
 * @param {*} rect 目标区域
 * @param {*} bdlevel 级别
 * @param {*} slevel 开始层级
 * @param {*} elevel 结束层级
 * @returns 
 */
function drawGridPrimitives3D(rect, bdlevel, slevel, elevel) {
    console.log("当前层级: ", bdlevel);
    // 第一级网格的经纬度间距
    var gridSpacingLon = BeidouGridMap[bdlevel][0];  // 经度间距 
    var gridSpacingLat = BeidouGridMap[bdlevel][1];  // 纬度间距 
    slevel = slevel || 0; //起始层数
    var gridHeightCount = elevel || BeidouGridHeightCountMap[bdlevel][0]; //终点层数
    var minLat = rect.minLat;  // 最小纬度
    var maxLat = rect.maxLat;  // 最大纬度
    var minLon = rect.minLon;  // 最小经度
    var maxLon = rect.maxLon;  // 最大经度

    // 存储 GeometryInstance
    var geometryInstances = [];
    // 遍历第一级网格的纬度和经度范围，生成网格的矩形
    let Ri = GlobeR;
    let sta = BeidouGridHeightCountMap[bdlevel][1];
    let Li = 0;
    for (var m = slevel; m < gridHeightCount; m++) {
        let distance = 0;
        Li = (Ri * Math.PI * sta) / 180;
        distance = distance + Li;
        for (var lat = minLat; lat <= maxLat; lat += gridSpacingLat) {
            for (var lon = minLon; lon <= maxLon; lon += gridSpacingLon) {
                // 调用函数创建梯形立方体
                var trapezoid = createTrapezoidByGrid(lon, lat, gridSpacingLon, gridSpacingLat, Ri - GlobeR, Ri - GlobeR + distance);
                geometryInstances.push(trapezoid);
            }
        }

        Ri = Ri + distance;
    }

    return geometryInstances;
}


/**
 * 
 * @param {*} lon 西南角经度
 * @param {*} lat 西南角纬度
 * @param {*} gridSpacingLon 网格经度差
 * @param {*} gridSpacingLat 网格经纬度
 * @param {*} hA 网格底部高度
 * @param {*} hB 网格顶部高度
 */
function createTrapezoidByGrid(lon, lat, gridSpacingLon, gridSpacingLat, hA, hB) {
    var west = lon; // 西边界
    var east = lon + gridSpacingLon; // 东边界
    var south = lat; // 南边界
    var north = lat + gridSpacingLat; // 北边界

    let pA_b = {
        x: west,
        y: south,
        z: hA
    };

    let pB_b = {
        x: east,
        y: south,
        z: hA
    };

    let pC_b = {
        x: east,
        y: north,
        z: hA
    };

    let pD_b = {
        x: west,
        y: north,
        z: hA
    };

    let pA_t = {
        x: west,
        y: south,
        z: hB
    };
    let pB_t = {
        x: east,
        y: south,
        z: hB
    };
    let pC_t = {
        x: east,
        y: north,
        z: hB
    };
    let pD_t = {
        x: west,
        y: north,
        z: hB
    };


    return {
        pA_b,
        pB_b,
        pC_b,
        pD_b,
        pA_t,
        pB_t,
        pC_t,
        pD_t
    };
}

function lineIntersectsTrapezoid3D(start, end, trapezoid) {

    var p0 = normalizePoint(start);
    var p1 = normalizePoint(end);

    // 由你现有 trapezoid 8 个点生成 AABB
    var minX = Math.min(trapezoid.pA_b.x, trapezoid.pC_t.x);
    var maxX = Math.max(trapezoid.pA_b.x, trapezoid.pC_t.x);
    var minY = Math.min(trapezoid.pA_b.y, trapezoid.pC_t.y);
    var maxY = Math.max(trapezoid.pA_b.y, trapezoid.pC_t.y);
    var minZ = Math.min(trapezoid.pA_b.z, trapezoid.pA_t.z);
    var maxZ = Math.max(trapezoid.pA_b.z, trapezoid.pA_t.z);

    var dx = p1.x - p0.x;
    var dy = p1.y - p0.y;
    var dz = p1.z - p0.z;

    var tmin = 0, tmax = 1;

    function slab(origin, dir, minB, maxB) {
        if (Math.abs(dir) < 1e-9) {
            return origin >= minB && origin <= maxB;
        }
        var t1 = (minB - origin) / dir;
        var t2 = (maxB - origin) / dir;
        if (t1 > t2) [t1, t2] = [t2, t1];
        if (t1 > tmax || t2 < tmin) return false;
        tmin = Math.max(tmin, t1);
        tmax = Math.min(tmax, t2);
        return true;
    }

    return (
        slab(p0.x, dx, minX, maxX) &&
        slab(p0.y, dy, minY, maxY) &&
        slab(p0.z, dz, minZ, maxZ)
    );
}


function getLineMinRect(start, end) {
    return {
        minLon: Math.min(start.lon, end.lon),
        maxLon: Math.max(start.lon, end.lon),
        minLat: Math.min(start.lat, end.lat),
        maxLat: Math.max(start.lat, end.lat)
    };
}

/**
 * 最终版：绘制带高程线路上的3D网格（简化相交逻辑）
 * @param {Object} startPoint 起点 {lon: 经度, lat: 纬度, alt: 高程（米，相对地表）}
 * @param {Object} endPoint 终点 {lon: 经度, lat: 纬度, alt: 高程（米，相对地表）}
 * @param {Number} bdlevel 网格层级
 * @param {Number} [customHeight] 自定义网格单层级高度（可选）
 * @returns {Array} 线路上网格的GeometryInstance数组
 */
function drawGridAlongLine3DWithSimpleIntersect(startPoint, endPoint, bdlevel, customHeight) {
    // 1. 参数校验
    const requiredKeys = ['lon', 'lat', 'alt'];
    if (!startPoint || !endPoint || !bdlevel || !BeidouGridMap[bdlevel]) {
        console.error("参数错误：起点/终点/层级不能为空，或层级配置不存在");
        return [];
    }
    if (!requiredKeys.every(key => key in startPoint) || !requiredKeys.every(key => key in endPoint)) {
        console.error("参数错误：起点/终点必须包含 lon、lat、alt 字段");
        return [];
    }
    const { lon: startLon, lat: startLat, alt: startAlt } = startPoint;
    const { lon: endLon, lat: endLat, alt: endAlt } = endPoint;
    if ([startLon, startLat, startAlt, endLon, endLat, endAlt].some(isNaN)) {
        console.error("参数错误：经纬度/高程必须为数字");
        return [];
    }

    // 2. 网格基础配置
    const gridSpacingLon = BeidouGridMap[bdlevel][0];
    const gridSpacingLat = BeidouGridMap[bdlevel][1];
    const gridHeightCount = BeidouGridHeightCountMap[bdlevel][0];
    const sta = BeidouGridHeightCountMap[bdlevel][1];
    const singleGridAltStep = customHeight || (GlobeR * Math.PI * sta) / 180; // 单层级高度（米）

    // 3. 线路包围矩形（缩小遍历范围）
    const minLon = Math.min(startLon, endLon);
    const maxLon = Math.max(startLon, endLon);
    const minLat = Math.min(startLat, endLat);
    const maxLat = Math.max(startLat, endLat);

    // 4. 存储结果
    const geometryInstances = [];

    // 5. 遍历网格 + 简化相交判断
    for (let lat = maxLat; lat >= minLat; lat -= gridSpacingLat) {
        for (let lon = minLon; lon <= maxLon; lon += gridSpacingLon) {
            // 遍历当前网格的每一层高度
            let currentBottomAlt = 0; // 网格底面高程（相对地表，初始0）
            for (let m = 0; m < gridHeightCount; m++) {
                const currentTopAlt = currentBottomAlt + singleGridAltStep; // 网格顶面高程

                // 核心判断：先判断线路与网格底面相交，再判断交点高程在网格范围内
                const isMatch = isLineIntersectGridBottomAndAltMatch(
                    startPoint, endPoint,
                    lon, lat,
                    gridSpacingLon, gridSpacingLat,
                    currentBottomAlt, currentTopAlt
                );

                if (isMatch) {
                    console.log(`网格[${lon},${lat}] 层级${m}：底面相交且高程匹配（${currentBottomAlt.toFixed(2)}~${currentTopAlt.toFixed(2)}米）`);
                    // 复用原有逻辑创建梯形立方体
                    const trapezoid = createTrapezoidByGrid(
                        lon, lat,
                        gridSpacingLon, gridSpacingLat,
                        currentBottomAlt, // 网格底面相对高程
                        currentTopAlt     // 网格顶面相对高程
                    );
                    geometryInstances.push(trapezoid);
                }

                // 更新下一层的底面高程
                currentBottomAlt = currentTopAlt;
            }
        }
    }

    console.log("最终匹配的线路网格总数：", geometryInstances.length);
    return geometryInstances;
}

//计算一级代号
BeidouGrid.calculateGridCode_1_lon = function (longitude) {
    // 将经度转换为 [-180, 180] 范围内的值
    var normalizedLongitude = ((longitude + 180) % 360) - 180;

    // 将经度转换为 [0, 360) 范围内的正数
    normalizedLongitude = (normalizedLongitude + 360) % 360;

    // 计算代号，从1开始
    var gridCode = Math.floor(normalizedLongitude / 6) + 1;

    // 将代号格式化为两位数，不足两位的前面补0
    var formattedGridCode = gridCode.toString().padStart(2, '0');

    return formattedGridCode;
}


BeidouGrid.calculateGridCode_1_lat = function (latitude) {
    // 将纬度转换为正数
    latitude = Math.abs(latitude);

    // 确保纬度在 [0, 88] 范围内
    if (latitude < 0 || latitude > 88) {
        throw new Error('Latitude must be between 0 and 88 degrees.');
    }

    // 计算代号索引
    var codeIndex = Math.floor(latitude / 4);

    // 生成代号，从A到V
    var code = String.fromCharCode('A'.charCodeAt(0) + codeIndex);

    return code;
}


//计算二级代号
BeidouGrid.calculateGridCode_2_lon = function (longitude) {
    // 将经度转换为 [-180, 180] 范围内的值
    var normalizedLongitude = ((longitude + 180) % 360) - 180;

    // 计算一级网格代号
    var secondaryGridCodeIndex;
    if (normalizedLongitude >= 0) {
        // 东半球：[0, 180]
        secondaryGridCodeIndex = Math.floor((normalizedLongitude % 6) / 0.5);
    } else {
        // 西半球：[-180, 0)
        secondaryGridCodeIndex = 11 - Math.floor(((normalizedLongitude + 360) % 6) / 0.5);
    }
    // 二级网格的代号用0到B表示
    var secondaryGridCode = secondaryGridCodeIndex.toString(16).toUpperCase();
    return secondaryGridCode;
}


BeidouGrid.calculateGridCode_2_lat = function (latitude) {
    // 确保纬度在 [-88, 88] 范围内
    if (latitude < -88 || latitude > 88) {
        throw new Error('Latitude must be between -88 and 88 degrees.');
    }

    // 计算二级网格代号
    latitude = Math.abs(latitude);
    var secondaryCodeIndex;
    secondaryCodeIndex = Math.floor((latitude % 4) / 0.5);
    // 二级网格的代号用0到7表示
    var secondaryCode = secondaryCodeIndex.toString();

    // 返回一级和二级网格代号
    return secondaryCode;
}

/**
 * 二维网格位置码
 */
BeidouGrid.getBD2DCODE = function (lon, lat) {
    let code_element_01 = "";
    code_element_01 = lat >= 0 ? "N" : "S";
    let code_element_23 = BeidouGrid.calculateGridCode_1_lon(lon);
    let code_element_04 = BeidouGrid.calculateGridCode_1_lat(lat);
    let code_element_05 = BeidouGrid.calculateGridCode_2_lon(lon);
    let code_element_06 = BeidouGrid.calculateGridCode_2_lat(lat);
}

/**
 * 北斗网格位置码（三维）计算-最长32位=20+12
 * 一级：七位
 * 二级：十位
 * 三级：十二位
 * 四级：十五位
 * 五级：十八位
 * 六级：二十位
 * 七级：二十三位
 * 八级：二十六位
 * 九级：二十九位
 * 十级：三十二位
 * @param {*} longitude 
 * @param {*} latitude 
 * @param {*} height 
 * @param {*} levelTop 
 * @returns 
 */
BeidouGrid.calculateGridCode3D_All = function (longitude, latitude, height, levelTop) {
    let BD_codes = [];
    levelTop = Number(levelTop);
    let lon_level_point; //该位置所在第i级二维北斗网格的定位角点经度;
    let lat_level_point; //该位置所在第i级二维北斗网格的定位角点纬度;
    let lon_level_col; //该位置在第i级二维北斗网格的列号;
    let lat_level_row; //该位置在第i级二维北斗网格的行号;
    let H_level_point; //该位置在第i级确定角点高度值;
    let H_level_grid;//该位置在第i级高度差
    let H_level_Num; //该位置在第i级高度编号;


    let lon_level_point_pre; //上一级确定角点经度值;
    let lat_level_point_pre; //上一级确定角点纬度值;
    let lon_level_col_pre; //上一级列号
    let lat_level_row_pre; //上一级行号
    let lon_level_grid_pre;  // 上一级经差;
    let lat_level_grid_pre;  // 上一级纬差;

    let H_level_point_pre; //上一级确定角点高度值;
    let H_level_grid_pre;//上一级高度差
    let H_level_Num_pre; //上一级确定高度编号;

    for (let level = 1; level <= levelTop; level++) {
        //一级有四个码元组成，示例：N45A
        if (level == 1) {
            let lon_level_grid = BeidouGridMap["bd_1"][0];  // 第i级二维北斗网格的经差;
            let lat_level_grid = BeidouGridMap["bd_1"][1];  // 第i级二维北斗网格的纬差。
            let h_level_grid = BeidouGridMap["bd_1"][2];  // 第i级二维北斗网格的高度差。

            let code_element_01 = "";
            code_element_01 = latitude >= 0 ? "N" : "S";
            lon_level_col = Math.floor(longitude / lon_level_grid) + 31;
            lat_level_row = Math.floor(Math.abs(latitude) / lat_level_grid);    //商取整【B/4】
            lon_level_col = Math.abs(lon_level_col);
            if (lon_level_col < 0) lon_level_col = 1;
            if (lon_level_col > 59) lon_level_col = 60;
            //修正a值
            if (lat_level_row > 22) lat_level_row = 22;

            let code_element_23 = lon_level_col.toString().padStart(2, '0');    //补足2位01-60
            let code_element_04 = String.fromCharCode('A'.charCodeAt(0) + lat_level_row);

            //高度码开始
            let code_height_01 = height >= 0 ? 0 : 1;
            let code_height_23 = Math.floor(height / h_level_grid).toString().padStart(2, '0'); //0到63
            //修正
            code_height_23 = code_height_23 >= 63 ? 63 : code_height_23;
            //高度码结束
            BD_codes.push(code_element_01 + code_height_01 + code_element_23 + code_element_04 + code_height_23);


            //==记录历史行列号和确定角点经纬度坐标值
            lon_level_col_pre = lon_level_col;
            lat_level_row_pre = lat_level_row;
            lon_level_point_pre = 0;   //全球赤道0度点
            lat_level_point_pre = 0;   //全球赤道0度点
            lon_level_grid_pre = lon_level_grid;
            lat_level_grid_pre = lat_level_grid;
            H_level_grid_pre = h_level_grid;
            H_level_Num_pre = Number(code_height_23);
            H_level_point_pre = 0;

        }
        //二级有六个码元组成，示例：
        if (level == 2) {
            let lon_level_grid = BeidouGridMap["bd_2"][0];  // 第i级二维北斗网格的经差;
            let lat_level_grid = BeidouGridMap["bd_2"][1];  // 第i级二维北斗网格的纬差。
            let h_level_grid = BeidouGridMap["bd_2"][2];  // 第i级二维北斗网格的高度差。

            //获取上一级网格层的确定角点经纬度坐标值
            lon_level_point = lon_level_point_pre + (lon_level_col_pre - 31) * lon_level_grid_pre;
            lat_level_point = lat_level_point_pre + (lat_level_row_pre) * lat_level_grid_pre;


            //获取此点在本级网格层的行列号                  
            lat_level_row = Math.floor((latitude - lat_level_point) / lat_level_grid) + 1;
            lon_level_col = Math.floor((longitude - lon_level_point) / lon_level_grid) + 1;
            let code_element_05 = fixRowColNum15(lon_level_col - 1);
            let code_element_06 = fixRowColNum15(lat_level_row - 1);


            //高度码开始
            H_level_point = H_level_point_pre + (H_level_Num_pre) * H_level_grid_pre;
            let code_height_04 = Math.floor((height - H_level_point) / h_level_grid) //0到7
            //修正
            code_height_04 = code_height_04 >= 7 ? 7 : code_height_04;
            //高度码结束

            BD_codes.push(code_element_05 + code_element_06 + code_height_04);

            //==记录历史行列号和确定角点经纬度坐标值
            lon_level_col_pre = lon_level_col;
            lat_level_row_pre = lat_level_row;
            lon_level_point_pre = lon_level_point;   //
            lat_level_point_pre = lat_level_point;   //
            lon_level_grid_pre = lon_level_grid;
            lat_level_grid_pre = lat_level_grid;
            H_level_grid_pre = h_level_grid;
            H_level_Num_pre = code_height_04;
            H_level_point_pre = H_level_point;

        }
        //三级有七个码元组成，示例：
        if (level == 3) {
            let lon_level_grid = BeidouGridMap["bd_3"][0];  // 第i级二维北斗网格的经差;
            let lat_level_grid = BeidouGridMap["bd_3"][1];  // 第i级二维北斗网格的纬差。
            let h_level_grid = BeidouGridMap["bd_3"][2];

            //获取上一级网格层的确定角点经纬度坐标值
            lon_level_point = lon_level_point_pre + (lon_level_col_pre - 1) * lon_level_grid_pre;
            lat_level_point = lat_level_point_pre + (lat_level_row_pre - 1) * lat_level_grid_pre;

            //获取此点在本级网格层的行列号                  
            lat_level_row = Math.floor((latitude - lat_level_point) / lat_level_grid) + 1;
            lon_level_col = Math.floor((longitude - lon_level_point) / lon_level_grid) + 1;

            let code_element_07 = fixRowColZorder(lat_level_row - 1, lon_level_col - 1);


            //高度码开始
            H_level_point = H_level_point_pre + (H_level_Num_pre) * H_level_grid_pre;
            let code_height_05 = Math.floor((height - H_level_point) / h_level_grid) //0到1
            //修正
            code_height_05 = code_height_05 >= 1 ? 1 : code_height_05;
            //高度码结束

            BD_codes.push(code_element_07 + code_height_05);

            //==记录历史行列号和确定角点经纬度坐标值
            lon_level_col_pre = lon_level_col;
            lat_level_row_pre = lat_level_row;
            lon_level_point_pre = lon_level_point;   //
            lat_level_point_pre = lat_level_point;   //
            lon_level_grid_pre = lon_level_grid;
            lat_level_grid_pre = lat_level_grid;
            H_level_grid_pre = h_level_grid;
            H_level_Num_pre = code_height_05;
            H_level_point_pre = H_level_point;

        }
        if (level >= 4 && level <= 5) {


            let lon_level_grid = BeidouGridMap["bd_" + level][0];  // 第i级二维北斗网格的经差;
            let lat_level_grid = BeidouGridMap["bd_" + level][1];  // 第i级二维北斗网格的纬差。
            let h_level_grid = BeidouGridMap["bd_" + level][2];

            //获取上一级网格层的确定角点经纬度坐标值
            lon_level_point = lon_level_point_pre + (lon_level_col_pre - 1) * lon_level_grid_pre;
            lat_level_point = lat_level_point_pre + (lat_level_row_pre - 1) * lat_level_grid_pre;

            //获取此点在本级网格层的行列号                  
            lat_level_row = Math.floor((latitude - lat_level_point) / lat_level_grid) + 1;
            lon_level_col = Math.floor((longitude - lon_level_point) / lon_level_grid) + 1;

            let code_element_r = fixRowColNum15(lat_level_row - 1);
            let code_element_c = fixRowColNum15(lon_level_col - 1);

            //高度码开始
            H_level_point = H_level_point_pre + (H_level_Num_pre) * H_level_grid_pre;
            let code_height_67 = Math.floor((height - H_level_point) / h_level_grid) //0到E
            //修正
            //高度码结束

            BD_codes.push(code_element_c);
            BD_codes.push(code_element_r);
            BD_codes.push(fixNumCode(code_height_67, "E"));

            //==记录历史行列号和确定角点经纬度坐标值
            lon_level_col_pre = lon_level_col;
            lat_level_row_pre = lat_level_row;
            lon_level_point_pre = lon_level_point;   //
            lat_level_point_pre = lat_level_point;   //
            lon_level_grid_pre = lon_level_grid;
            lat_level_grid_pre = lat_level_grid;
            H_level_grid_pre = h_level_grid;
            H_level_Num_pre = code_height_67;
            H_level_point_pre = H_level_point;

        }
        if (level == 6) {

            let lon_level_grid = BeidouGridMap["bd_6"][0];  // 第i级二维北斗网格的经差;
            let lat_level_grid = BeidouGridMap["bd_6"][1];  // 第i级二维北斗网格的纬差。
            let h_level_grid = BeidouGridMap["bd_6"][2];


            //获取上一级网格层的确定角点经纬度坐标值
            lon_level_point = lon_level_point_pre + (lon_level_col_pre - 1) * lon_level_grid_pre;
            lat_level_point = lat_level_point_pre + (lat_level_row_pre - 1) * lat_level_grid_pre;

            //获取此点在本级网格层的行列号                  
            lat_level_row = Math.floor((latitude - lat_level_point) / lat_level_grid) + 1;
            lon_level_col = Math.floor((longitude - lon_level_point) / lon_level_grid) + 1;

            let code_element = fixRowColZorder(lat_level_row - 1, lon_level_col - 1);

            //高度码开始
            H_level_point = H_level_point_pre + (H_level_Num_pre) * H_level_grid_pre;
            let code_height_06 = Math.floor((height - H_level_point) / h_level_grid) //0到1
            code_height_06 = code_height_06 >= 1 ? 1 : code_height_06;
            //修正
            //高度码结束

            BD_codes.push(code_element);
            BD_codes.push(code_height_06);

            //==记录历史行列号和确定角点经纬度坐标值
            lon_level_col_pre = lon_level_col;
            lat_level_row_pre = lat_level_row;
            lon_level_point_pre = lon_level_point;   //
            lat_level_point_pre = lat_level_point;   //
            lon_level_grid_pre = lon_level_grid;
            lat_level_grid_pre = lat_level_grid;
            H_level_grid_pre = h_level_grid;
            H_level_Num_pre = code_height_06;
            H_level_point_pre = H_level_point;

        }
        if (level >= 7 && level <= 10) {

            let lon_level_grid = BeidouGridMap["bd_" + level][0];  // 第i级二维北斗网格的经差;
            let lat_level_grid = BeidouGridMap["bd_" + level][1];  // 第i级二维北斗网格的纬差。
            let h_level_grid = BeidouGridMap["bd_" + level][2];

            //获取上一级网格层的确定角点经纬度坐标值
            lon_level_point = lon_level_point_pre + (lon_level_col_pre - 1) * lon_level_grid_pre;
            lat_level_point = lat_level_point_pre + (lat_level_row_pre - 1) * lat_level_grid_pre;

            //获取此点在本级网格层的行列号                  
            lat_level_row = Math.floor((latitude - lat_level_point) / lat_level_grid) + 1;
            lon_level_col = Math.floor((longitude - lon_level_point) / lon_level_grid) + 1;

            let code_element_r = fixRowColNum15(lat_level_row - 1);
            let code_element_c = fixRowColNum15(lon_level_col - 1);

            //高度码开始
            H_level_point = H_level_point_pre + (H_level_Num_pre) * H_level_grid_pre;
            let code_height_710 = Math.floor((height - H_level_point) / h_level_grid) //0到7
            code_height_710 = code_height_710 >= 7 ? 7 : code_height_710;
            //修正
            //高度码结束

            BD_codes.push(code_element_c);
            BD_codes.push(code_element_r);
            BD_codes.push(code_height_710);

            //==记录历史行列号和确定角点经纬度坐标值
            lon_level_col_pre = lon_level_col;
            lat_level_row_pre = lat_level_row;
            lon_level_point_pre = lon_level_point;   //
            lat_level_point_pre = lat_level_point;   //
            lon_level_grid_pre = lon_level_grid;
            lat_level_grid_pre = lat_level_grid;
            H_level_grid_pre = h_level_grid;
            H_level_Num_pre = code_height_710;
            H_level_point_pre = H_level_point;
        }
    }

    return BD_codes.join("")

}

/**
 * 横向12个格子，0到B表示
 * 纵向八个格子，0到7表示
 */
function fixRowColNum15(gridCodeIndex) {
    var codeNum = gridCodeIndex.toString(16).toUpperCase();
    return codeNum;

}

function fixRowColZorder(row, col) {
    let table = [
        ["0", "1"],
        ["2", "3"],
        ["4", "5"]
    ]
    return table[row][col]
}

function fixNumCode(input, max) {
    const range = '0123456789ABCDEFGHIJKLMNPQRSTUVWXYZ'; // 包含0到E的字符集
    if (input < 0) {
        return '0'; // 如果输入小于0，返回最小值
    } else if (input > range.indexOf(max)) {
        return max; // 如果输入大于E，返回E
    } else {
        return range[input]; // 返回对应的字符
    }
}


export default BeidouGrid;